import { ApiService } from 'services';
import { toastr } from 'react-redux-toastr';

import { handleException } from 'actions/exceptions';

export const EDIT_ACCOUNT_DUE_DILIGENCE = 'EDIT_ACCOUNT_DUE_DILIGENCE';
export const EDIT_ACCOUNT_DUE_DILIGENCE_CANCEL = 'EDIT_ACCOUNT_DUE_DILIGENCE_CANCEL';
export const UPDATE_ACCOUNT_DUE_DILIGENCE_REQUEST = 'UPDATE_ACCOUNT_DUE_DILIGENCE_REQUEST';
export const UPDATE_ACCOUNT_DUE_DILIGENCE_SUCCESS = 'UPDATE_ACCOUNT_DUE_DILIGENCE_SUCCESS';
export const UPDATE_ACCOUNT_DUE_DILIGENCE_ERROR = 'UPDATE_ACCOUNT_DUE_DILIGENCE_ERROR';

function edit() {
  return {
    type: EDIT_ACCOUNT_DUE_DILIGENCE
  };
}

function cancelEdit() {
  return {
    type: EDIT_ACCOUNT_DUE_DILIGENCE_CANCEL
  };
}

function request() {
  return {
    type: UPDATE_ACCOUNT_DUE_DILIGENCE_REQUEST
  };
}

function receive(dueDiligence) {
  return {
    type: UPDATE_ACCOUNT_DUE_DILIGENCE_SUCCESS,
    dueDiligence
  };
}

function reject() {
  return {
    type: UPDATE_ACCOUNT_DUE_DILIGENCE_ERROR
  };
}

export function editAccountDueDiligence() {
  return (dispatch) => {
    dispatch(edit());
  };
}

export function cancelEditAccountDueDiligence() {
  return (dispatch) => {
    dispatch(cancelEdit());
  };
}

export function updateAccountDueDiligence(accountId, dueDiligence) {
  const formData = new FormData();
  formData.append('dueDiligenceProcedure', dueDiligence);

  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .updateAccountDueDiligence(accountId, formData)
      .then(() => {
        dispatch(receive((dueDiligence === null || dueDiligence === undefined) ? null : Number(dueDiligence)));
        toastr.success('Success', 'Due diligence updated successfully');
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
